<template>
  <vs-popup class="add-new-company-holiday" id="popup" title="VIEW SUNDRY INVENTORY QC TEST" @close="open = false" :active.sync="open"
    :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateQcTest)" autocomplete="off">
          <vx-card subtitle="" >
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="q_c_status" name="q_c_status" rules="required" v-slot="{ errors }">
                  <small class="label">Status</small>
                  <v-select disabled :clearable="true" name="status" placeholder="" v-model="form.status" label="name"
                    :reduce="option => option.value"
                    :options="[{ name: 'Approved', value: 'approved' }, { name: 'Rejected', value: 'rejected' }]"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Is item damaged?</small>
                  <vs-switch disabled v-model="form.not_damaged" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Is item dry?</small>
                  <vs-switch disabled v-model="form.dry" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Is item clean?</small>
                  <vs-switch disabled v-model="form.clean" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="re_sample" name="re_sample" rules="required" v-slot="{ errors }">
                  <small class="label">Shrink wrap intact?</small>
                  <vs-switch disabled v-model="form.shrink_wrap_intact" icon-pack="feather" vs-icon-on="icon-check-circle"
                    vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                  <small class="label">Notes</small>
                  <vs-textarea disabled class="mb-0" v-model="form.notes" height="150px" />
                  <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
              
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const SundrySupplierRepository = RepositoryFactory.get('sundry')
const ManufacturingRepository = RepositoryFactory.get('manufacturing');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from "vue-select";

function initialState() {
  return {
    open: false,
    id: '',
    rm_item: {},
    form: {
      not_damaged: false,
      dry: false,
      clean: false,
      shrink_wrap_intact: false,
      notes: '',
      q_c_status: ''
    },
    stock_inventory_form: {},
  }
}

export default {
  name: 'ViewQcTestSundryOrderItemPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(data) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        this.form = data
      } catch (error) {

      }
    },
    async onClickCreateQcTest() {
      
    },
  },
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-company-holiday>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}</style>
